import { connect as connectBase } from 'react-redux';
import { InjectedFormProps } from 'redux-form';

export const connect = <StateProps, DispatchProps, OwnProps, StoreState>(
  ...props
) => (Children) => {
  return connectBase<
    StateProps,
    DispatchProps,
    Partial<OwnProps & InjectedFormProps<OwnProps>>,
    StoreState
  >(...(props as [any]))(Children);
};
